import { render, staticRenderFns } from "./KLine.vue?vue&type=template&id=07bf6164&"
import script from "./KLine.vue?vue&type=script&lang=js&"
export * from "./KLine.vue?vue&type=script&lang=js&"
import style0 from "./KLine.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "KLine.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsSlider } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VFlex,
  VLayout,
  VTab,
  VTabs,
  VTabsSlider,
})
